// @flow
import React, { Component } from 'react'
import _ from 'lodash'

import {
  Table as MainTable,
  HeaderCell,
  HeaderRow,
  Cell,
  BodyRow,
  Link
} from '../../components/MainTable'
import Button from '../controls/PrimaryButton'
import styled from 'styled-components'
import FormContainer from './FormContainer'
import type { Configs, Leadform, LeadformResponse } from '../types'
import type { SocialPublicProps } from '../../redux/ducks/audienceEdit/reducers'

const spaceBetweenButtons = 14

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: ${-spaceBetweenButtons}px;
`

const TopButton: typeof Button = (styled(Button): any).attrs({ small: true })`
  margin-right: ${spaceBetweenButtons}px;
`

const t = {
  create: 'Создать',
  name: 'Название'
}

type Props = {|
  initial: {|
    items: Array<LeadformResponse>,
    socialPublicProps: SocialPublicProps,
    isOrtAccounts: boolean,
    adAccountId: number,
    configs: Configs
  |},
  onInit: (items: Array<LeadformResponse>) => void,
  onCreate: () => void,
  items: Array<Leadform>,
  onEdit: (id: number) => void
|}

export default class Table extends Component<Props> {
  constructor(props: Props) {
    super(props)
    window.leadformsTableComponent = this // for tests
    props.onInit(this.props.initial.items)
  }

  render() {
    return (
      <div>
        <FormContainer
          configs={this.props.initial.configs}
          isOrtAccounts={this.props.initial.isOrtAccounts}
          socialPublicProps={this.props.initial.socialPublicProps}
          adAccountId={this.props.initial.adAccountId}
        />
        <ButtonWrapper>
          <TopButton onClick={() => this.props.onCreate()}>{t.create}</TopButton>
        </ButtonWrapper>
        <MainTable>
          <thead>
            <HeaderRow>
              <HeaderCell alignLeft>#</HeaderCell>
              <HeaderCell alignLeft>{t.name}</HeaderCell>
            </HeaderRow>
          </thead>
          <tbody>
            {_.map(this.props.items, (item) => (
              <BodyRow key={item.id}>
                <Cell>{item.id}</Cell>
                <Cell>
                  <Link onClick={() => this.props.onEdit(item.id)}>{item.name}</Link>
                </Cell>
              </BodyRow>
            ))}
          </tbody>
        </MainTable>
      </div>
    )
  }
}
